export const REPORT_MASTER_DETAIL_REQUEST = 'REPORT_MASTER_DETAIL_REQUEST';
export const REPORT_MASTER_DETAIL_REQUEST_SUCCESS = 'REPORT_MASTER_DETAIL_REQUEST_SUCCESS';
export const REPORT_MASTER_DETAIL_REQUEST_FAILURE = 'REPORT_MASTER_DETAIL_REQUEST_FAILURE';
export const GET_REPORT_MASTER_DETAIL = 'GET_REPORT_MASTER_DETAIL';
export const REPORT_MASTER_WITH_DETAIL_REQUEST = 'REPORT_MASTER_WITH_DETAIL_REQUEST';
export const REPORT_MASTER_WITH_DETAIL_REQUEST_SUCCESS = 'REPORT_MASTER_WITH_DETAIL_REQUEST_SUCCESS';
export const REPORT_MASTER_WITH_DETAIL_REQUEST_FAILURE = 'REPORT_MASTER_WITH_DETAIL_REQUEST_FAILURE';
export const GET_REPORT_MASTER_WITH_DETAIL = 'GET_REPORT_MASTER_WITH_DETAIL';